import { nullish } from "./nullish";

// Chain of Responsibility in TypeScript
export abstract class Validator<TModel = any, TError = string> {
    nextValidator: Validator<TModel, TError>;

    validate(model: TModel, errors: TError): TError {
        if (!nullish(this.nextValidator)) {
            return this.nextValidator.validate(model, errors);
        }

        return errors;
    }

    setNextValidator(validator) {
        this.nextValidator = validator;
    }
}

export class ValidatorChainBuilder<TModel = any, TError = string> {
    first: Validator<TModel, TError>;
    last: Validator<TModel, TError>;

    add(validator: Validator<TModel, TError>) {
        if (!this.first) {
            this.first = validator;
            this.last = validator;
            return this;
        }
        this.last.setNextValidator(validator);
        this.last = validator;
        return this;
    }

    getFirst() {
        return this.first;
    }
}
